module.exports = __webpack_public_path__ + "static/img/ball.968b8229.webp";